// User properties that can be set in Amplitude
export interface AmplitudeUserProperties {
  email?: string
  name?: string
  plan?: 'free' | 'pro' | 'enterprise'
  createdAt?: string
  // Add more user properties as needed
}

// Common event properties that can be tracked
export interface AmplitudeEventProperties {
  [key: string]: any
}

// Specific event property interfaces
export interface GetStartedClickedProperties {
  url: string
  description: string
  location: 'header' | 'hero' | 'final-cta'
  isAuthenticated: boolean
  timestamp: string
}

export interface AuthEventProperties {
  url: string
  description: string
  authMethod: 'google' | 'email'
  timestamp: string
}

export interface CopyCodeClickedProperties {
  url: string
  description: string
  timestamp: string
}

// Predefined event names (to be added when implementing events)
// Using const assertion instead of enum for TypeScript compatibility
export const AmplitudeEvents = {
  // Authentication events
  USER_SIGNED_UP: 'User Signed Up',
  USER_LOGGED_IN: 'User Logged In',
  USER_LOGGED_OUT: 'User Logged Out',

  // User interaction events
  GET_STARTED_CLICKED: 'Get Started Clicked',

  // Authentication button events
  GOOGLE_SIGN_UP_PRESSED: 'Google Sign Up Pressed',
  GOOGLE_SIGN_IN_PRESSED: 'Google Sign In Pressed',
  CREATE_ACCOUNT_PRESSED: 'Create Account Pressed',
  SIGN_IN_PRESSED: 'Sign In Pressed',

  // Dashboard events
  COPY_CODE_CLICKED: 'Copy Code Clicked',
} as const

export type AmplitudeEventName = (typeof AmplitudeEvents)[keyof typeof AmplitudeEvents]

// Amplitude service state
export interface AmplitudeState {
  isInitialized: boolean
  isEnabled: boolean
}
